export enum LogTopic {
  DISPLAY_MAPPING = 'DisplayMapping', //display -> device -> screenshot mapping
}

export enum LogLevel {
  INFO = 'INFO',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
}
